var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whole-calendar-card"},[(_vm.squareCardActive)?_c('div',{staticClass:"whole-calendar-card__card-list"},[_vm._t("eventCard")],2):_vm._e(),_c('div',{staticClass:"calendar-wrap"},[_vm._t("calendar")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }